import lottie from 'lottie-web'
import Flickity from 'flickity'
import Cookies from 'js-cookie'
import { isNull, isUndefined } from '../misc/Utils'

export default class Home {
    constructor() {
        this.cacheDom()
        this.bindEvents()
        this.initialize()
    }

    cacheDom() {
        this.desktop = window.matchMedia('(min-width: 1024px)').matches
        this.flkty = null
        this.animation = null
        this.bodyEl = document.body
        this.lottieEl = document.querySelector('.play-button')
        this.triggerPlay = document.querySelector('.home-hero-button')
        this.featuredProductCarousel = document.querySelector('.featured-products-carousel')
        this.featuredProductActive = document.getElementById('featured-products-active')
        this.featuredProductTotal = document.getElementById('featured-products-total')
        this.arrows = document.querySelectorAll('.featured-products-arrows')
        this.hero = document.querySelector('.home-hero-main')
        this.notice = document.querySelector('.home-hero-notice')
        this.noticeTrigger = document.querySelector('.home-hero-notice button')

        this.video = document.querySelector('.video-wrapper video')
        this.videoModal = document.querySelector('.video-modal')
        this.videoOverlay = document.querySelector('.video-modal-overlay')
        this.closeVideoModal = document.querySelector('.video-modal-close')
    }

    initialize() {
        if (!isNull(this.lottieEl)) {
            this.animation = lottie.loadAnimation({
                container: this.lottieEl,
                path: 'https://assets8.lottiefiles.com/private_files/lf30_913akr74.json',
                renderer: 'svg',
                loop: true,
                autoplay: false,
                name: 'play',
            })
        }

        if (!isNull(this.featuredProductCarousel)) {
            this.flkty = new Flickity(this.featuredProductCarousel, {
                cellAlign: 'left',
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                on: {
                    ready: this.handleCarouselInit()
                }
            })

            this.flkty.on('change', this.handleCarouselChange.bind(this))
        }

        this.handleNotice()
    }

    bindEvents() {
        if (!isNull(this.triggerPlay)) {
            this.triggerPlay.addEventListener('mouseout', () => {
                this.animation.stop()
            })

            this.triggerPlay.addEventListener('mouseover', () => {
                this.animation.play()
            })

            this.triggerPlay.addEventListener('click', this.videoHandler.bind(this))
            this.closeVideoModal.addEventListener('click', this.videoHandler.bind(this))
            this.videoOverlay.addEventListener('click', this.videoHandler.bind(this))
            document.addEventListener('keydown', this.handleKeyDown.bind(this))
        }

        if (!isNull(this.arrows)) {
            Array.prototype.forEach.call(this.arrows, (element) => {
                element.addEventListener('click', this.handleArrowClick.bind(this))
            })
        }

        if (!isNull(this.noticeTrigger)) {
            this.noticeTrigger.addEventListener('click', this.handleNoticeTrigger.bind(this))
        }
    }

    videoHandler(event) {
        event.preventDefault()

        if (this.videoModal.classList.contains('is-visible')) {
            this.videoModal.classList.remove('is-visible')
            this.bodyEl.classList.remove('overflow-hidden')
            this.video.pause()
            return
        }

        this.bodyEl.classList.add('overflow-hidden')
        this.videoModal.classList.add('is-visible')
        this.video.play()
    }

    handleKeyDown(event) {
        if (event.keyCode === 27 || event.key === 'Escape') {
            if (this.videoModal.classList.contains('is-visible')) {
                this.videoHandler(event)
            }
        }
    }

    handleArrowClick(event) {
        event.preventDefault()
        const target = event.target

        if (target.classList.contains('next')) {
            this.flkty.next(true, false)
        } else {
            this.flkty.previous(true, false)
        }
    }

    handleCarouselInit() {
        if (!this.desktop || isNull(this.featuredProductTotal)) {
            return
        }

        const total = parseInt(this.featuredProductTotal.innerHTML)

        if (!isNaN(total) && total <= 3) {
            this.featuredProductActive.innerHTML = total

            this.arrows.forEach((arrow) => {
                arrow.remove()
            })
        }
    }

    handleCarouselChange(index) {
        index++
        this.featuredProductActive.innerHTML = index
    }

    handleNotice() {
        const notice = Cookies.get('hide_notice')
        const isEnabled = this.hero.dataset.enableNotice

        if (isUndefined(notice) && isEnabled === 'true') {
            this.hero.classList.add('home-hero-main--notice')
            this.notice.classList.add('is-visible')
            return
        }
    }

    handleNoticeTrigger(event) {
        Cookies.set('hide_notice', true, { expires: 7 })
        this.notice.classList.remove('is-visible')
        this.hero.classList.remove('home-hero-main--notice')
    }
}
